// Link Object sample
// {
//     path: '/blog', <-- path to the page you want to go to
//     displayTranslationKey: 'nav.blog',  <-- VUE translation that should be displayed
//     props: any additional props that a link may need
//      --> direct: true <-- means the link shouldn't be altered (for external links)
//      --> notifications: true <-- means the link can have notifications like inbox
// }
import { OC_PLUS_LOGO } from '@marketplace/config/ocplus.js'

export const PROFILE_SUBMENU_LINKS = [
    // links that appear under the person icon
    {
        href: '/backoffice',
        displayTranslationKey: 'nav.go_to_manager',
        name: 'Marketplace Account Dropdown Backoffice',
        props: {
            icon: 'far fa-home',
            class: 'block lg:hidden',
        },
        hiddenFor: ['retailer'],
    },
    {
        path: '/account/orders',
        displayTranslationKey: 'nav.menu_orders',
        name: 'Account Dropdown Orders',
        props: {
            icon: 'far fa-archive',
        },
    },
    {
        path: '/account/invoices',
        displayTranslationKey: 'nav.menu_invoices',
        name: 'Account Dropdown Invoices',
        props: {
            icon: 'far fa-receipt',
        },
    },
    {
        path: '/account/brands',
        displayTranslationKey: 'nav.menu_brands',
        name: 'Account Dropdown Brands',
        props: {
            icon: 'far fa-store-alt',
        },
    },
    {
        path: '/account/favorites',
        displayTranslationKey: 'nav.menu_favorites',
        name: 'Account Dropdown Favorites',
        props: {
            icon: 'far fa-heart',
        },
    },
    {
        path: '/account/plus',
        displayTranslationKey: OC_PLUS_LOGO.normal.dark,
        name: 'ocplus',
        props: {
            icon: 'far fa-plus',
            useHtml: true,
        },
        hiddenFor: ['isOCPlus', 'notAssociationMember', 'supplier'],
    },
    {
        path: '/account/inbox',
        displayTranslationKey: 'nav.menu_inbox',
        name: 'Account Dropdown Inbox',
        props: {
            notifications: true,
            icon: 'far fa-envelope',
        },
    },
    {
        path: '/account/edit',
        displayTranslationKey: 'nav.menu_account_information',
        name: 'Account Dropdown Account',
        props: {
            icon: 'far fa-user-friends',
        },
        hiddenFor: ['supplier'],
    },
    {
        component: 'CurrentLanguageMenuItem',
        atClick: 'triggerLanguageCurrencyModal',
    },
    {
        href: '/auth/logout',
        displayTranslationKey: 'nav.menu_logout',
        name: 'Account Dropdown Logout',
        props: {
            icon: 'far fa-power-off',
        },
    },
]

// exceptions (these links open modals)
export const GUEST_LINKS = [
    // links that appear under the person icon (unlogged)
    {
        action: 'modal-login',
        displayTranslationKey: 'nav.log_in',
        name: 'Login',
        url: '/auth/login',
        props: {},
        type: 'link',
    },
    {
        action: 'modal-retailer-signup',
        displayTranslationKey: 'nav.sign_up',
        name: 'Sign Up',
        url: '/retailers',
        props: {},
        type: 'button',
    },
]

export const DROPSHIPPING_SUBMENU_LINKS = [
    {
        href: '/backoffice',
        displayTranslationKey: 'nav.go_to_manager',
        name: 'Dropshipping Account Dropdown Backoffice',
        props: {
            icon: 'far fa-home',
        },
        hiddenFor: ['retailer'],
    },
    {
        path: '/ds/settings/account',
        routeName: 'ds-settings-account',
        displayTranslationKey: 'nav_account_settings',
        name: 'Dropshipping Account Dropdown Settings',
        props: {
            icon: 'far fa-user',
        },
    },
    {
        href: 'https://support.orderchamp.com/hc/en-150/categories/4408624674705-For-Retailers',
        displayTranslationKey: 'nav_support',
        name: 'Dropshipping Account Dropdown Support',
        props: {
            icon: 'far fa-question-circle',
        },
        target: '_blank',
    },
    {
        component: 'CurrentLanguageMenuItem',
        atClick: 'triggerLanguageCurrencyModal',
    },
    {
        href: '/auth/logout',
        displayTranslationKey: 'nav.menu_logout',
        name: 'Dropshipping Account Dropdown Logout',
        props: {
            icon: 'far fa-power-off',
        },
    },
]
